import { ScrollTrigger } from "gsap/ScrollTrigger";

const Usecases = () => {
	const block = document.querySelectorAll(".usecases");
	if (!block) {
		return;
	}
	const scrollTriggerRefresh = () => {
		setTimeout(() => {
			ScrollTrigger.refresh();
		}, 200);
	};

	block.forEach((el) => {
		const items = el.querySelectorAll(".usecases__tiles-item");
		const listItems = el.querySelectorAll(".usecases__list-item");
		const footer = el.querySelector(".usecases__footer");
		const moreControl = el.querySelector(".usecases__footer .custom-link");
		const isWithLoading = el.classList.contains("usecases_with-loading");
		const itemsCount = 4;
		let itemsToShow = isWithLoading ? 2 : 12;

		if (items) {
			moreControl.addEventListener("click", (e) => {
				itemsToShow = itemsToShow + itemsCount;

				// tiles
				if (items.length) {
					items.forEach((item, index) => {
						if (index < itemsToShow && !item.classList.contains("active")) {
							item.classList.add("active");
						}
					});

					if (itemsToShow >= items.length) {
						footer.classList.add("usecases__footer_hide")
					}
				}

				// list
				if (listItems.length) {
					listItems.forEach((item, index) => {
						if (index < itemsToShow && !item.classList.contains("active")) {
							item.classList.add("active");
						}
					});

					if (itemsToShow >= listItems.length) {
						footer.classList.add("usecases__footer_hide")
					}
				}

				scrollTriggerRefresh();
			});
		}
	});
};

export default Usecases;
